module.exports = "/images/magnet-1960.jpg?ada6a5345f0fce517b7eb7d34ebcbc9f";